"use client"

import { Send } from "lucide-react"
import { CONTACTS } from "@/lib/contacts"

export function TelegramWidget() {
  return (
    <a
      href={CONTACTS.social.telegram}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-40 hidden sm:flex size-14 items-center justify-center rounded-full bg-[#2AABEE] text-white shadow-lg transition-transform hover:scale-110 hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2AABEE] focus-visible:ring-offset-2 group"
      aria-label="Написать в Telegram"
    >
      {/* Pulse ring */}
      <span className="absolute inset-0 animate-ping rounded-full bg-[#2AABEE] opacity-20" />
      <Send className="relative size-7" />
      {/* Tooltip */}
      <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 whitespace-nowrap rounded-md bg-foreground px-2.5 py-1 text-xs font-medium text-background opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Написать в Telegram
      </span>
    </a>
  )
}
